import fetch from "../../uilts/request.js";

export default {

   open(data) {
    return fetch.post('/JuZheng/open', data)
  },
   handleSubmit(data) {
    return fetch.post('/JuZheng/handleSubmit', data)
  },
   getSignH5(data) {
    return fetch.post('/JuZheng/getSignH5', data)
  },
   queryOrderStatus (data) {
    return fetch.post('/JuZheng/queryOrderStatus ', data)
  },
 downloadNotary (data) {
    return fetch.post('/JuZheng/downloadNotary ', data)
  },
  
}